// components/WalkInVehicleModal.jsx
import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";

const WalkInVehicleModal = ({ show, handleClose, onSubmit, defaultReg = "" }) => {
    const [saving, setSaving] = useState(false);
    const [form, setForm] = useState({
        vehicleRegistrationNumber: "",
        vehicleModel: "",
        phoneNumber: "",
        name: "",
        kitType: "",
    });

    useEffect(() => {
        if (show) {
            setForm((p) => ({
                ...p,
                vehicleRegistrationNumber: defaultReg || p.vehicleRegistrationNumber,
            }));
        } else {
            setSaving(false);
            setForm({
                vehicleRegistrationNumber: "",
                vehicleModel: "",
                phoneNumber: "",
                name: "",
                kitType: "",
            });
        }
    }, [show, defaultReg]);

    const handleChange = (e) =>
        setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

    const submit = async (e) => {
        e.preventDefault();
        if (!form.vehicleRegistrationNumber?.trim()) return;

        setSaving(true);

        const payload = {
            vehicleRegistrationNumber: form.vehicleRegistrationNumber.trim(),
            vehicleModel: form.vehicleModel?.trim() || "",
            phoneNumber: form.phoneNumber?.trim() || "",
            name: form.name?.trim() || "",
            kitType: form.kitType?.trim() || "",
        };

        const res = await onSubmit(payload);

        setSaving(false);

        // close only if success
        if (res?.responseCode === 1) handleClose();
    };

    return (
        <Modal
            show={show}
            onHide={saving ? undefined : handleClose}
            centered
            backdrop="static"
            keyboard={!saving}   // allow ESC when not saving
        >
            <Modal.Header closeButton={!saving}>
                <Modal.Title>Register Walk-in Vehicle</Modal.Title>
            </Modal.Header>

            <Form onSubmit={submit}>
                <Modal.Body>
                    <Row className="g-3">
                        <Col md={12}>
                            <Form.Group>
                                <Form.Label>Vehicle Registration Number *</Form.Label>
                                <Form.Control
                                    name="vehicleRegistrationNumber"
                                    value={form.vehicleRegistrationNumber}
                                    onChange={handleChange}
                                    placeholder="e.g. KDA 123A"
                                    required
                                    disabled={saving}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={12}>
                            <Form.Group>
                                <Form.Label>Vehicle Model</Form.Label>
                                <Form.Control
                                    name="vehicleModel"
                                    value={form.vehicleModel}
                                    onChange={handleChange}
                                    placeholder="e.g. Toyota Hilux"
                                    disabled={saving}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Customer Name</Form.Label>
                                <Form.Control
                                    name="name"
                                    value={form.name}
                                    onChange={handleChange}
                                    placeholder="Walk-in customer"
                                    disabled={saving}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Phone Number</Form.Label>
                                <Form.Control
                                    name="phoneNumber"
                                    value={form.phoneNumber}
                                    onChange={handleChange}
                                    placeholder="07xx..."
                                    disabled={saving}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={12}>
                            <Form.Group>
                                <Form.Label>Kit Type</Form.Label>
                                <Form.Control
                                    name="kitType"
                                    value={form.kitType}
                                    onChange={handleChange}
                                    placeholder="e.g. LPG / CNG"
                                    disabled={saving}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose} disabled={saving}>
                        Cancel
                    </Button>
                    <Button type="submit" variant="primary" disabled={saving}>
                        {saving ? "Registering..." : "Register"}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default WalkInVehicleModal;
